import { render, staticRenderFns } from "./UpgradeCollector.vue?vue&type=template&id=716daaec"
import script from "./UpgradeCollector.vue?vue&type=script&lang=js"
export * from "./UpgradeCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716daaec')) {
      api.createRecord('716daaec', component.options)
    } else {
      api.reload('716daaec', component.options)
    }
    module.hot.accept("./UpgradeCollector.vue?vue&type=template&id=716daaec", function () {
      api.rerender('716daaec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Collector/UpgradeCollector.vue"
export default component.exports